import apiClient from './apiClient';

export async function fetchPentestTools() {
  const { data } = await apiClient.get('/pentest/tools');
  return data.map((t) => ({
    id: t.name === 'OWASP ZAP' ? 'ZAP' : t.name.toUpperCase(),
    name: t.name, category: t.integration, description: t.detail,
    status: t.available ? 'ready' : 'restricted'
  }));
}

export async function fetchPentestEngagements() {
  const { data } = await apiClient.get('/pentest/engagements');
  const now = Date.now();
  return data.filter((e) => e.status === 'APPROVED' && new Date(e.window_start).getTime() <= now && new Date(e.window_end).getTime() >= now);
}

// Unfiltered — feeds the engagement management/approval UI, as opposed to
// fetchPentestEngagements() above which narrows to "currently scannable".
export async function fetchAllEngagements() {
  const { data } = await apiClient.get('/pentest/engagements');
  return data;
}

export async function createEngagement(payload) {
  const { data } = await apiClient.post('/pentest/engagements', payload);
  return data;
}

export async function approveEngagement(id) {
  const { data } = await apiClient.put(`/pentest/engagements/${id}/approve`);
  return data;
}

export async function rejectEngagement(id, reason) {
  const { data } = await apiClient.put(`/pentest/engagements/${id}/reject`, { reason });
  return data;
}

export async function revokeEngagement(id) {
  const { data } = await apiClient.put(`/pentest/engagements/${id}/revoke`);
  return data;
}

export async function fetchScanJobs() {
  const { data } = await apiClient.get('/pentest/jobs');
  return data.map((j) => ({
    ...j, findings: j.finding_count, startedAt: j.started_at || j.created_at,
    requestedBy: j.requested_by, status: String(j.status).toLowerCase()
  }));
}

export async function fetchPentestReports() {
  const { data } = await apiClient.get('/pentest/jobs');
  return data.filter((j) => j.status === 'COMPLETED').map((j) => ({
    id: j.id, title: `${j.tool} assessment — ${j.target}`, client: j.target,
    date: String(j.completed_at || j.created_at).slice(0, 10),
    findings: { critical: 0, high: j.finding_count || 0, medium: 0, low: 0 }
  }));
}

export async function launchScan(engagementId, toolId, target) {
  const { data } = await apiClient.post(`/pentest/engagements/${engagementId}/scan`, { tool: toolId, target });
  return {
    ...data, findings: data.finding_count, startedAt: data.started_at || data.created_at,
    requestedBy: data.requested_by, status: String(data.status).toLowerCase()
  };
}
